import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import { swalConfirm, swalError, swalSuccess } from "../../../../helpers/swal";

import * as Action from "../../../applicant/_redux/applicantActions";
const _init = {
  name: "",
  designation: "",
  organisation: "",
  phone: "",
  email: "",
  relation: "",
  address: "",
};

const References = ({ id }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [portfolioData, setPortfolioData] = useState({ list: [_init] });

  // Validation schema
  const validationSchema = Yup.object().shape({
    list: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required("Name is required"),
        designation: Yup.string().required("Designation is required"),
        organisation: Yup.string().required("Organisation is required"),
        phone: Yup.string()
          .required("Phone is required")
          .matches(
            /^\d{1,11}$/,
            "Phone number must be at most 11 digits and contain only numbers"
          ),
        email: Yup.string()
          .required("Email is required")
          .email("Invalid email format")
          .matches(
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            "Email must not contain special characters or spaces"
          ),
        relation: Yup.string().required("Relation is required"),
        address: Yup.string().required("Address is required"),
      })
    ),
  });
  const handleSaveProfile = async (values) => {
    const response = await API.patch(
      "hrms_applicant/save-references?id=" + id,
      values.list
    );
    if (response.data.success) {
      swalSuccess(response.data.message);

      dispatch(
        Action.createProfileScore(
          {
            name: ["References"],
            applicant_id: id,
          },
          () => {
            dispatch(Action.getApplicantPersonalInfo(id));
            fetchData();
          }
        )
      );
      // fetchData();
    } else {
      swalError(response.data.message);
    }
  };

  const handleDeleteLanguage = async (itemId, index) => {
    swalConfirm().then(async (res) => {
      if (res.isConfirmed) {
        const list = portfolioData?.list;
        list.splice(index, 1);
        setPortfolioData({ list: list });
      }
    });
  };
  const handleAddLanguage = async (values) => {
    const newArray = [...values.list];
    let data = [...newArray, _init];
    setPortfolioData({ list: data });
  };
  const fetchData = async () => {
    const response = await API.get("hrms_applicant/get-references/" + id);

    if (response.data.success) {
      // console.log(response);
      if (response.data.data.length) {
        setPortfolioData({
          list: response.data.data.map((d) => {
            return {
              id: d.id,
              name: d.name,
              designation: d.designation,
              organisation: d.organisation,
              phone: d.phone,
              email: d.email,
              address: d.address,
              relation: d.relation,
            };
          }),
        });
      }
    } else {
      swalError(response.data.message);
    }
  };
  useEffect(() => {
    if (id) {
      // get-objective
      fetchData();
    }
  }, [id]);
  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={portfolioData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSaveProfile(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>References</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            {values?.list?.map((item, i, row) => (
              <div className="row" key={i}>
                <div className="col-md-12 mb-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].name`}
                            label={"Name"}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(`list[${i}].name`, e.target.value);
                            }}
                            value={item.name}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].name`} />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].designation`}
                            label={"Designation"}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].designation`,
                                e.target.value
                              );
                            }}
                            value={item.designation}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].designation`} />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].organisation`}
                            label={"Organisation"}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].organisation`,
                                e.target.value
                              );
                            }}
                            value={item.organisation}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].organisation`} />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].address`}
                            label={"Address"}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].address`,
                                e.target.value
                              );
                            }}
                            value={item.address}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].address`} />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].phone`}
                            label={"Phone"}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(`list[${i}].phone`, e.target.value);
                            }}
                            value={item.phone}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].phone`} />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].email`}
                            label={"Email"}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(`list[${i}].email`, e.target.value);
                            }}
                            value={item.email}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].email`} />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].relation`}
                            label={"Relation"}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].relation`,
                                e.target.value
                              );
                            }}
                            value={item.relation}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].relation`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3 pt-10">
                          {i === values?.list?.length - 1 && (
                            <button
                              className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                              onClick={(e) => {
                                e.preventDefault();
                                handleAddLanguage(values);
                              }}
                            >
                              <i
                                className="fa fa-plus text-white"
                                aria-hidden="true"
                              ></i>
                              Add Reference
                            </button>
                          )}

                          {row.length > 1 && (
                            <button
                              className="btn btn-danger btn-sm  text-nowrap"
                              onClick={(e) => {
                                e.preventDefault();
                                handleDeleteLanguage(item.id, i);
                              }}
                            >
                              <i
                                className="fa fa-minus  text-white"
                                aria-hidden="true"
                              ></i>
                              Remove Reference
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              {/* <button className='btn btn-default mr-4' >Cancel</button> */}
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default References;
